import { Component, Input } from '@angular/core';

@Component({
    selector: 'gt-loading',
    templateUrl: './gt-loading.component.html',
    styleUrls: ['./gt-loading.component.scss'],
    standalone: true
})
export class GtLoadingComponent {
  @Input()
  public message = 'Taking you to greytHR, in a while';
}
